<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'shape-links-Generator-Root',
};
</script>
